// extracted by mini-css-extract-plugin
module.exports = {"root":"_2XvDMD8rI-gD","account":"XnZbOdSrOIPw","control":"_2UHM0BPIeB1-"};